import React, { useState, useEffect } from "react";
import * as S from "./styles";

import { useUserRegister } from "contexts/register/UserContext";
import { format } from "date-fns";
import { IScheduleSubmitProps } from "interfaces/Schedule";
import MaskedInput from "../../../MaskedInput";

type Props = {
  isEditing: boolean;
};

export function ScheduleForm({ isEditing }: Props) {
  const { schedule, setSchedule, errors, removeError } = useUserRegister();

  const [mondayEntryText, setMondayEntryText] = useState("");
  const [mondayExitText, setMondayExitText] = useState("");
  const [tuesdayEntryText, setTuesdayEntryText] = useState("");
  const [tuesdayExitText, setTuesdayExitText] = useState("");
  const [wednesdayEntryText, setWednesdayEntryText] = useState("");
  const [wednesdayExitText, setWednesdayExitText] = useState("");
  const [thursdayEntryText, setThursdayEntryText] = useState("");
  const [thursdayExitText, setThursdayExitText] = useState("");
  const [fridayEntryText, setFridayEntryText] = useState("");
  const [fridayExitText, setFridayExitText] = useState("");
  const [saturdayEntryText, setSaturdayEntryText] = useState("");
  const [saturdayExitText, setSaturdayExitText] = useState("");
  const [sundayEntryText, setSundayEntryText] = useState("");
  const [sundayExitText, setSundayExitText] = useState("");

  const [loading, setLoading] = useState<boolean>(true);

  const hourFormatChars = (value: string) => {
    if (value[0] === "0") {
      return {
        "2": "[0-2]",
        "3": "[0-9]",
        "5": "[0-5]",
        "9": "[0-9]",
      };
    }
    return {
      "2": "[0-2]",
      "3": "[0-3]",
      "5": "[0-5]",
      "9": "[0-9]",
    };
  };

  useEffect(() => {
    setMondayEntryText(localStorage.getItem("mondayEntry") ?? "");
    setMondayExitText(localStorage.getItem("mondayExit") ?? "");
    setTuesdayEntryText(localStorage.getItem("tuesdayEntry") ?? "");
    setTuesdayExitText(localStorage.getItem("tuesdayExit") ?? "");
    setWednesdayEntryText(localStorage.getItem("wednesdayEntry") ?? "");
    setWednesdayExitText(localStorage.getItem("wednesdayExit") ?? "");
    setThursdayEntryText(localStorage.getItem("thursdayEntry") ?? "");
    setThursdayExitText(localStorage.getItem("thursdayExit") ?? "");
    setFridayEntryText(localStorage.getItem("fridayEntry") ?? "");
    setFridayExitText(localStorage.getItem("fridayExit") ?? "");
    setSaturdayEntryText(localStorage.getItem("saturdayEntry") ?? "");
    setSaturdayExitText(localStorage.getItem("saturdayExit") ?? "");
    setSundayEntryText(localStorage.getItem("sundayEntry") ?? "");
    setSundayExitText(localStorage.getItem("sundayExit") ?? "");
  }, []);

  useEffect(() => {
    if (schedule.id) {
      setMondayEntryText(format(schedule.mondayEntry, "HH:mm"));
      setMondayExitText(format(schedule.mondayExit, "HH:mm"));
      setTuesdayEntryText(format(schedule.tuesdayEntry, "HH:mm"));
      setTuesdayExitText(format(schedule.tuesdayExit, "HH:mm"));
      setWednesdayEntryText(format(schedule.wednesdayEntry, "HH:mm"));
      setWednesdayExitText(format(schedule.wednesdayExit, "HH:mm"));
      setThursdayEntryText(format(schedule.thursdayEntry, "HH:mm"));
      setThursdayExitText(format(schedule.thursdayExit, "HH:mm"));
      setFridayEntryText(format(schedule.fridayEntry, "HH:mm"));
      setFridayExitText(format(schedule.fridayExit, "HH:mm"));
      setSaturdayEntryText(format(schedule.saturdayEntry, "HH:mm"));
      setSaturdayExitText(format(schedule.saturdayExit, "HH:mm"));
      setSundayEntryText(format(schedule.sundayEntry, "HH:mm"));
      setSundayExitText(format(schedule.sundayExit, "HH:mm"));

      return setLoading(false);
    }

    return setLoading(false);
  }, [schedule]);

  type FormatHourProps = {
    value: string;
    text: string;
    setText: (value: string) => void;
    key: keyof IScheduleSubmitProps;
  };

  function formatHour({ value, setText, key }: FormatHourProps) {
    try {
      setText(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})\d+?$/, "$1")
      );
      const [hours, min] = value.split(":");

      setSchedule((_value) => {
        if (key !== "id") {
          _value[key] = new Date(2022, 1, 14, Number(hours), Number(min));
          return _value;
        }
        console.log(_value);
        _value[key] = value;
        return _value;
      });
    } catch {
      return;
    }
  }

  if (loading) return <></>;

  return (
    <S.Wrapper>
      <S.ScheduleModalForm>
        <S.DayContainer>
          <span>Segunda</span>
          <S.DayInputContainer>
            <MaskedInput
              id="monday entry"
              name="monday entry"
              type="text"
              defaultValue={mondayEntryText}
              placeholder="Entrada:"
              required={true}
              mask={"29:59"}
              formatChars={hourFormatChars(mondayEntryText)}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setMondayEntryText,
                  text: mondayEntryText,
                  key: "mondayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("mondayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setMondayEntryText,
                  text: mondayEntryText,
                  key: "mondayEntry",
                });
              }}
              error={errors["schedule.mondayEntry"]}
              apiErrorName={"schedule.mondayEntry"}
              handleApiErrorRemove={() => removeError("schedule.mondayEntry")}
            />
            <MaskedInput
              id="monday exitText"
              name="monday exitText"
              type="text"
              placeholder="saida:"
              mask={"29:59"}
              formatChars={hourFormatChars(mondayExitText)}
              required={true}
              defaultValue={mondayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setMondayExitText,
                  text: mondayExitText,
                  key: "mondayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("mondayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setMondayExitText,
                  text: mondayExitText,
                  key: "mondayExit",
                });
              }}
              error={errors["schedule.mondayExit"]}
              apiErrorName={"schedule.mondayExit"}
              handleApiErrorRemove={() => removeError("schedule.mondayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Sexta</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              formatChars={hourFormatChars(fridayEntryText)}
              id="friday entry"
              name="friday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              defaultValue={fridayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setFridayEntryText,
                  text: fridayEntryText,
                  key: "fridayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("fridayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setFridayEntryText,
                  text: fridayEntryText,
                  key: "fridayEntry",
                });
              }}
              error={errors["schedule.fridayEntry"]}
              apiErrorName={"schedule.fridayEntry"}
              handleApiErrorRemove={() => removeError("schedule.fridayEntry")}
            />
            <MaskedInput
              mask={"29:59"}
              id="friday exit"
              name="friday exit"
              type="text"
              placeholder="saida:"
              required={true}
              formatChars={hourFormatChars(fridayExitText)}
              defaultValue={fridayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setFridayExitText,
                  text: fridayExitText,
                  key: "fridayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("fridayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setFridayExitText,
                  text: fridayExitText,
                  key: "fridayExit",
                });
              }}
              error={errors["schedule.fridayExit"]}
              apiErrorName={"schedule.fridayExit"}
              handleApiErrorRemove={() => removeError("schedule.fridayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Terça</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              id="tuesday entry"
              name="tuesday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              formatChars={hourFormatChars(tuesdayEntryText)}
              defaultValue={tuesdayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setTuesdayEntryText,
                  text: tuesdayEntryText,
                  key: "tuesdayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("tuesdayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setTuesdayEntryText,
                  text: tuesdayEntryText,
                  key: "tuesdayEntry",
                });
              }}
              error={errors["schedule.tuesdayEntry"]}
              apiErrorName={"schedule.tuesdayEntry"}
              handleApiErrorRemove={() => removeError("schedule.tuesdayEntry")}
            />
            <MaskedInput
              mask={"29:59"}
              formatChars={hourFormatChars(tuesdayExitText)}
              id="tuesday exit"
              name="tuesday exit"
              type="text"
              placeholder="saida:"
              required={true}
              defaultValue={tuesdayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setTuesdayExitText,
                  text: tuesdayExitText,
                  key: "tuesdayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("tuesdayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setTuesdayExitText,
                  text: tuesdayExitText,
                  key: "tuesdayExit",
                });
              }}
              error={errors["schedule.tuesdayExit"]}
              apiErrorName={"schedule.tuesdayExit"}
              handleApiErrorRemove={() => removeError("schedule.tuesdayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Sábado</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              id="saturday entry"
              name="saturday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              formatChars={hourFormatChars(saturdayEntryText)}
              defaultValue={saturdayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setSaturdayEntryText,
                  text: saturdayEntryText,
                  key: "saturdayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("saturdayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setSaturdayEntryText,
                  text: saturdayEntryText,
                  key: "saturdayEntry",
                });
              }}
              error={errors["schedule.saturdayEntry"]}
              apiErrorName={"schedule.saturdayEntry"}
              handleApiErrorRemove={() => removeError("schedule.saturdayEntry")}
            />
            <MaskedInput
              mask={"29:59"}
              formatChars={hourFormatChars(saturdayExitText)}
              id="saturday exit"
              name="saturday exit"
              type="text"
              placeholder="saida:"
              required={true}
              defaultValue={saturdayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setSaturdayExitText,
                  text: saturdayExitText,
                  key: "saturdayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("saturdayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setSaturdayExitText,
                  text: saturdayExitText,
                  key: "saturdayExit",
                });
              }}
              error={errors["schedule.saturdayExit"]}
              apiErrorName={"schedule.saturdayExit"}
              handleApiErrorRemove={() => removeError("schedule.saturdayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Quarta</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              formatChars={hourFormatChars(wednesdayEntryText)}
              id="wednesday entry"
              name="wednesday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              defaultValue={wednesdayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setWednesdayEntryText,
                  text: wednesdayEntryText,
                  key: "wednesdayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("wednesdayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setWednesdayEntryText,
                  text: wednesdayEntryText,
                  key: "wednesdayEntry",
                });
              }}
              error={errors["schedule.wednesdayEntry"]}
              apiErrorName={"schedule.wednesdayEntry"}
              handleApiErrorRemove={() =>
                removeError("schedule.wednesdayEntry")
              }
            />
            <MaskedInput
              mask={"29:59"}
              id="wednesday exit"
              name="wednesday exit"
              type="text"
              placeholder="saida:"
              required={true}
              formatChars={hourFormatChars(wednesdayExitText)}
              defaultValue={wednesdayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setWednesdayExitText,
                  text: wednesdayExitText,
                  key: "wednesdayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("wednesdayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setWednesdayExitText,
                  text: wednesdayExitText,
                  key: "wednesdayExit",
                });
              }}
              error={errors["schedule.wednesdayExit"]}
              apiErrorName={"schedule.wednesdayExit"}
              handleApiErrorRemove={() => removeError("schedule.wednesdayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Domingo</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              id="sunday entry"
              name="sunday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              formatChars={hourFormatChars(sundayEntryText)}
              defaultValue={sundayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setSundayEntryText,
                  text: sundayEntryText,
                  key: "sundayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("sundayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setSundayEntryText,
                  text: sundayEntryText,
                  key: "sundayEntry",
                });
              }}
              error={errors["schedule.sundayEntry"]}
              apiErrorName={"schedule.sundayEntry"}
              handleApiErrorRemove={() => removeError("schedule.sundayEntry")}
            />
            <MaskedInput
              mask={"29:59"}
              id="sunday exit"
              name="sunday exit"
              type="text"
              placeholder="saida:"
              formatChars={hourFormatChars(sundayExitText)}
              required={true}
              defaultValue={sundayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setSundayExitText,
                  text: sundayExitText,
                  key: "sundayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("sundayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setSundayExitText,
                  text: sundayExitText,
                  key: "sundayExit",
                });
              }}
              error={errors["schedule.sundayExit"]}
              apiErrorName={"schedule.sundayExit"}
              handleApiErrorRemove={() => removeError("schedule.sundayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>

        <S.DayContainer>
          <span>Quinta</span>
          <S.DayInputContainer>
            <MaskedInput
              mask={"29:59"}
              formatChars={hourFormatChars(thursdayEntryText)}
              id="thursday entry"
              name="thursday entry"
              type="text"
              placeholder="Entrada:"
              required={true}
              defaultValue={thursdayEntryText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setThursdayEntryText,
                  text: thursdayEntryText,
                  key: "thursdayEntry",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("thursdayEntry", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setThursdayEntryText,
                  text: thursdayEntryText,
                  key: "thursdayEntry",
                });
              }}
              error={errors["schedule.thursdayEntry"]}
              apiErrorName={"schedule.thursdayEntry"}
              handleApiErrorRemove={() => removeError("schedule.thursdayEntry")}
            />
            <MaskedInput
              mask={"29:59"}
              id="thursday exit"
              name="thursday exit"
              type="text"
              placeholder="saida:"
              required={true}
              formatChars={hourFormatChars(thursdayExitText)}
              defaultValue={thursdayExitText}
              onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                formatHour({
                  value: e.clipboardData.getData("Text"),
                  setText: setThursdayExitText,
                  text: thursdayExitText,
                  key: "thursdayExit",
                });
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                localStorage.setItem("thursdayExit", event.target.value);
                formatHour({
                  value: event.target.value,
                  setText: setThursdayExitText,
                  text: thursdayExitText,
                  key: "thursdayExit",
                });
              }}
              error={errors["schedule.thursdayExit"]}
              apiErrorName={"schedule.thursdayExit"}
              handleApiErrorRemove={() => removeError("schedule.thursdayExit")}
            />
          </S.DayInputContainer>
        </S.DayContainer>
      </S.ScheduleModalForm>
    </S.Wrapper>
  );
}
